module.exports = __webpack_public_path__ + "static/img/TM.dff29801.svg";